import { useState } from "react";
import Header from "../components/Header";
import api from "../lib/api";

const TOPICS = ["Consultancy", "Conciergerie", "Connectivity", "Speaking", "Contribution", "Press & Media", "Other"];
const EYEBROW = { Consultancy: "Advisory", Conciergerie: "Agency", Connectivity: "Assembly" };

export default function Contact() {
  const [f, setF] = useState({ first: "", last: "", email: "", phone: "", topic: new URLSearchParams(window.location.search).get("topic") || "", message: "" });
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (!f.first || !f.last || !f.email) { setErr("First name, last name and work email are required."); return; }
    try {
      await api.post("/leads", { first_name: f.first, last_name: f.last, email: f.email, phone: f.phone, message: f.message,
        interests: [`Contact: ${f.topic || "General"}`], source_page: "/contact" });
      setDone(true);
    } catch { setErr("Something went wrong. Please try again."); }
  };
  const field = "w-full bg-transparent border border-sage/40 px-4 py-3 text-sm outline-none focus:border-forest placeholder:text-ink/40";
  return (
    <div className="min-h-screen bg-ivory text-ink">
      <Header active="contact" />
      <section className="pt-36 pb-24 px-6 lg:px-10 max-w-6xl mx-auto grid lg:grid-cols-[340px_1fr] gap-12 items-start" data-testid="contact-page">
        <div className="relative p-[9px] border border-gold max-w-sm w-full mx-auto lg:mt-4 order-2 lg:order-1 shadow-[0_0_24px_rgba(201,162,92,0.12)]" data-testid="contact-photo">
          <div className="relative aspect-[3/4] overflow-hidden">
            <img src="/photos/contact-goa.jpg" alt="Nitasha Sarin, Founder of LUXEWELL, in Goa" className="contact-grade w-full h-full object-cover" />
            <div className="absolute inset-x-0 bottom-0 pt-20 p-4 bg-gradient-to-t from-black/70 via-black/30 to-transparent" data-testid="contact-photo-caption">
              <p className="font-headline text-ivory text-lg">Nitasha Sarin, MSc MBA</p>
              <p className="eyebrow !text-[0.52rem] !text-[#E8D29B] mt-0.5">Founder, LUXEWELL</p>
              <p className="font-sans text-ivory/90 text-[0.62rem] mt-2 tracking-wide" data-testid="contact-photo-sabbatical">Annual Founder Strategic Sabbatical<sup className="text-[0.6em]">™</sup> · Goa, India</p>
            </div>
          </div>
        </div>
        <div className="order-1 lg:order-2">
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight" data-testid="contact-heading">SAY <span className="font-sign text-gold text-6xl sm:text-7xl tracking-normal lowercase">hello</span> TO THE HOUSE</h1>
        <p className="mt-5 font-headline italic text-xl text-ink/70">Tell us what you have in mind, and Team LUXEWELL will reply personally within 48 hours.</p>
        {done ? (
          <div className="mt-12 py-10 text-center border border-gold/40" data-testid="contact-confirmation">
            <p className="font-display text-2xl">Thank you & welcome to the House</p>
            <p className="mt-3 text-sm text-ink/70">Team LUXEWELL will be in touch within 48 hours.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-12 grid sm:grid-cols-2 gap-3" data-testid="contact-form">
            <input data-testid="contact-firstname" required value={f.first} onChange={set("first")} placeholder="First name *" className={field} />
            <input data-testid="contact-lastname" required value={f.last} onChange={set("last")} placeholder="Last name *" className={field} />
            <input data-testid="contact-email" type="email" required value={f.email} onChange={set("email")} placeholder="Work email *" className={field} />
            <input data-testid="contact-phone" value={f.phone} onChange={set("phone")} placeholder="Phone (optional)" className={field} />
            <div className="sm:col-span-2 mt-2" data-testid="contact-topic">
              <p className="eyebrow !text-[0.58rem] mb-3">I'm interested in…</p>
              <div className="flex flex-wrap gap-2 items-end">
                {TOPICS.map((t) => (
                  <div key={t}>
                    {EYEBROW[t] && <p className="eyebrow !text-[0.5rem] !text-gold mb-1">{EYEBROW[t]}</p>}
                    <button type="button" onClick={() => setF({ ...f, topic: t })} data-testid={`contact-topic-${t.split(" ")[0].toLowerCase()}`}
                      className={`eyebrow !text-[0.6rem] border px-4 py-2 transition-colors ${f.topic === t ? "border-gold bg-gold !text-ink" : "border-sage/40 !text-ink/70 hover:border-gold"}`}>{t}</button>
                  </div>
                ))}
              </div>
            </div>
            <textarea data-testid="contact-message" value={f.message} onChange={set("message")} rows={5} placeholder="Your message" className={`${field} sm:col-span-2 resize-none`} />
            {err && <p className="text-sm text-red-600 sm:col-span-2" data-testid="contact-error">{err}</p>}
            <button type="submit" data-testid="contact-submit" className="btn-lux sm:col-span-2 w-full sm:w-fit bg-forest text-ivory hover:bg-gold hover:text-ink mt-2">Send message</button>
          </form>
        )}
        <div className="mt-10 space-y-4" data-testid="contact-email-address">
          <p><span className="eyebrow !text-gold block mb-1">Consultancy · Conciergerie · Connectivity</span>
            <a href="mailto:explore@luxewellexperiences.com" className="text-base font-headline text-ink hover:text-gold">explore@luxewellexperiences.com</a></p>
          <p><span className="eyebrow !text-gold block mb-1">Partnerships · Speaking · Media</span>
            <a href="mailto:team@globalifegroup.com" className="text-base font-headline text-ink hover:text-gold">team@globalifegroup.com</a></p>
        </div>
        </div>
      </section>
    </div>
  );
}
